export default { sha: 'a7b6d6ef13212d7c27506682700c96d17decc2b2', buildNumber: 'undefined' }
